import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import SleepUserDetail from '../../../SleepHub/SleepUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanySleepUserDetail } from './companySleepApi';

/**
 * Company Sleep → one employee's/member's sleep profile. Reuses the shared
 * detail page with the company-scoped fetcher (the backend 404s any user who
 * doesn't belong to this company).
 */
const CSleepUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Sleep Profile | Shoorah</title>
      </Helmet>
      <SleepUserDetail
        fetcher={fetchCompanySleepUserDetail}
        backPath={`/${slug}/sleep/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CSleepUserDetail;
